import { UserAddress } from '../models/user.model';

export class AddressUtil {
  static getFormattedAddress(address: UserAddress): string {
    return `${address.street}, ${address.number || ''} - ${address.city || ''}/${address.state || ''}`;
  }
}
